import React from 'react';
import ReportingGiftCardsRedemptionsPage from '../components/ReportingGiftCardsRedemptionsPage';

const ReportingGiftCardsRedemptionsApp = (props) => (
  <ReportingGiftCardsRedemptionsPage {...props} />
);

export default ReportingGiftCardsRedemptionsApp;
